export default __webpack_public_path__ + "static/media/Joanne_Light_AHV_In_Moms_We_Trust.56b075f0.jpg";